var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container pagination"},[_c('el-pagination',{attrs:{"page-size":_vm.itemsOnPage,"pager-count":_vm.docWidth < 450 ? 4 : 7,"layout":"prev, pager, next","total":_vm.totalItems,"current-page":_vm.currentPage},on:{"current-change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }